<template>
    <div class="table-container">
        <div class="title">
            <span>
                Recurring SMS Campaigns
            </span>
            <div>
                <v-btn
                    :disabled="!hasCreatePrivilege"
                    class="edit-btn"
                    @click="goToCreateRecurringSMSCampaign()"
                >
                    Create New
                </v-btn>
            </div>
        </div>
        <array-view
            :items="smsCampaigns"
            :headers="headers"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :total-items="totalItems"
            :is-fetching="isFetchingCampaigns"
            :is-delete-disabled="!hasDeletePrivilege"
            :is-edit-disabled="!hasEditPrivilege"
            @refresh-data="refreshData"
            @paginationChange="paginationChange"
            @updateCampaign="updateCampaignItem"
        />
    </div>
</template>

<script>
    import recurringSmsCampaignService from '@/services/recurring-sms-campaign-service'
    import ArrayView from '@/components/ArrayView'
    import { hasPrivilege } from '@/utils/userUtils'
    import { PRIVILEGES } from '@/utils/consts'
    export default {
        components: { ArrayView },
        data() {
            return {
                headers: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'User',
                        value: 'username'
                    },
                    { text: 'Originator', value: 'originator' },
                    { text: 'Created At', value: 'createdAt' },
                    { text: 'Alias', value: 'alias' },
                    { text: 'Actions', align: 'center', value: 'actions', sortable: false }
                ],
                smsCampaigns: [],
                totalPages: 0,
                size: 5,
                page: 1,
                totalItems: 0,
                sortKey: 'id',
                sortOrder: 'ASC',
                isFetchingCampaigns: false
            }
        },
        computed: {
            hasDeletePrivilege() {
                return hasPrivilege(
                    PRIVILEGES.RECURRING_SMS_CAMPAIGN_DELETE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasEditPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.RECURRING_SMS_CAMPAIGN_UPDATE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasCreatePrivilege() {
                return hasPrivilege(
                    PRIVILEGES.RECURRING_SMS_CAMPAIGN_CREATE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            }
        },
        watch: {
            page: 'applyFiltersToQuery',
            size: 'applyFiltersToQuery',
            sortKey: 'applyFiltersToQuery',
            sortOrder: 'applyFiltersToQuery'
        },
        created() {
            this.initializeFilters()
            this.fetchAllSMSCampaigns()
        },
        methods: {
            refreshData() {
                this.fetchAllSMSCampaigns()
            },
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.fetchAllSMSCampaigns()
            },
            goToCreateRecurringSMSCampaign() {
                this.$router.push('/recurring-sms/create')
            },
            fetchAllSMSCampaigns() {
                this.isFetchingCampaigns = true
                recurringSmsCampaignService.getAllSMSCampaigns(this.page, this.size, this.sortKey, this.sortOrder)
                    .then(resp => {
                        this.smsCampaigns = resp.data.content || []
                        this.totalPages = resp.data.totalPages || 0
                        this.totalItems = resp.data.totalElements || 0
                    })
                    .catch(error => {
                        console.error('Error fetching Recurring SMS Campaign:', error)
                    })
                    .finally(() => {
                        this.isFetchingCampaigns = false
                    })
            },
            updateCampaignItem(campaignIndex, property, val) {
                const campaign = this.smsCampaigns.find(c => c.id === campaignIndex)
                campaign[property] = val
            },
            initializeFilters() {
                const query = this.$route.query
                if (query.page) this.page = parseInt(query.page)
                if (query.pageSize) this.size = parseInt(query.pageSize)
                if (query.sortKey) this.sortKey = query.sortKey
                if (query.sortOrder) this.sortOrder = query.sortOrder
            },
            applyFiltersToQuery() {
                const query = {
                    page: this.page,
                    pageSize: this.size,
                    sortKey: this.sortKey,
                    sortOrder: this.sortOrder
                }
                this.$router.replace({ query })
            }
        }
    }
</script>

<style scoped>
    .title {
        font-size: 1.5rem !important;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
    }

    .edit-btn {
        text-transform: none !important;
        background: #00acd6 !important;
        color: white;
        margin: 15px auto;
    }

</style>
